import { format } from 'date-fns';

/**
 * Format Date to YYYY-MM-DD for backend consumption
 * 
 * Bug Fix: .toISOString() converts local Date to UTC, causing date shift
 * Example: new Date('2025-10-01 00:00:00 GMT+0700').toISOString()
 *          => '2025-09-30T17:00:00.000Z' (wrong date!)
 * 
 * Solution: Use date-fns format() to preserve local timezone
 * 
 * @param date - Local Date object
 * @returns YYYY-MM-DD string in local timezone, or undefined if no date
 */
export const formatDateForBackend = (date: Date | undefined): string | undefined => {
  if (!date) return undefined;
  
  // ✅ Hardcoded: Always use date-fns format (preserves local timezone)
  // Previously controlled by ENABLE_LOCAL_DATE_FILTER flag (stable since 2025-09)
  return format(date, 'yyyy-MM-dd');
};
